export const COLORS = [
    // https://sashat.me/2017/01/11/list-of-20-simple-distinct-colors/
    '#ffe119', '#4363d8', '#f58231', '#fabebe', '#e6beff', '#800000', '#000075', '#a9a9a9', '#ffffff', '#000000'
];
export const SHAPE_COUNT = 5;
